import React from 'react';
import { Card, CardContent, Button, Typography, Box } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import fail from "../../assets/fail.png"
import {

  IconButton,
  Divider,
} from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
const Fail = () => {
   const { orderId } = useParams();
    const navigate = useNavigate();
  const handleClose = () => {
navigate(`/activeOrder/true/${orderId}`, { replace: true });
  };

   const handleTry = () => {
    navigate(`/vendOrder/number/${orderId}`);
  };

        const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const fetchCode = async () => {
      try {
        const response = await axios.get(
          `https://api-prod.daalchini.co.in/consumerbe/api/v1/contactless/generate-code/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${UserJWTAuth}`,
              "x-app-platform": "web",
              "x-app-version": "v1.0.1",
              "x-device-id": localStorage.getItem("uuid"),
            },
          }
        );
        //console.log("busy khan", response);
        //setCodes(response.data.data.codes);
        //setOrderId(response.data.data.orderId);
         //setBusyFlag(false)
         //setBusyPopupFlag(true)
           navigate(`/vendOrder/number/${orderId}`); 
       
      } catch (err) {
        console.error("busy khan ❌ Fetch error",);
         //setBusyFlag(true)
         //setBusyPopupFlag(true)
      }
    };     
  return (
    <Box>
         <Box
        sx={{
          bgcolor: "#fae14b",
          p: 1.5,
          display: "flex",
          alignItems: "center",
              position: "fixed",
    width: "100%"
        }}
      >
        <IconButton size="small" sx={{ mr: 1 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Match The Number
        </Typography>
      </Box>

    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            {/* Header */}
    
      <Card sx={{ maxWidth: 400, border: '1px solid #F44336', borderRadius: 2 }}>
        <CardContent sx={{ textAlign: 'center', padding: 4 }}>
            <Box display={"flex"}    justifyContent= {"center"}>
          <img
            src={fail} // Replace this with the actual path to your image
            alt="Incorrect"
            style={{ width: 50, height: 50 }} // Adjust size accordingly
          />
          </Box>
          <Typography variant="h6" sx={{ color: '#F44336', marginY: 2 }}>
            Incorrect Response
          </Typography>
          <Button
            variant="outlined"
            color="error"
            sx={{ marginTop: 2 ,width:"100%"}}
           
             onClick={handleTry}
          >
            Retry
          </Button>
        </CardContent>
      </Card>
    </Box>
    </Box>
  );
};

export default Fail;
